export default "https://cdn-static.gokick.com/assets/e21cd8011b9b3a74c4cd288f1b94a870d12ac47c/images/gokick-home-thumb.d0805bfbe5c122bc4415664ec8f6d56b.png";